require('sass/brands/locations.wendys.com/search/default.scss');
require('js/search-script.js');
